// removed by extract-text-webpack-plugin
module.exports = {"button":"Button__button___CqOtg","flex":"Button__flex___3Trxy"};